<template>
  <div class="privacyGame">
      <!-- style="color: red;" -->     
         <p>《梅州实渲用户协议》（以下简称“本协议”）由您与梅州实渲网络科技有限责任公司（以下简称“本公司”）共同缔结，<b> 本协议具有合同效力。为保障您的合法权益，请您在同意并接受本协议所有条款前务必审慎阅读、充分理解各条款内容，特别是免除或限制本公司责任的条款（以下称“免责条款”）、对您的权利进行限制的条款（以下称“限制条款”）、约定争议解决方式和司法管辖的条款。前述免责、限制及争议解决方式及其他重要条款将以黑体加粗的方式或其他合理方式提示您注意，该等条款包括但不限于本协议第三条、第四条、第五条、第七条、第八条、第十四条等相关条款，您对该等条款的确认有可能导致您在特定情况下的被动、不便、损失，请您在确认同意本协议之前或在使用本公司游戏服务之前务必阅读前述条款。


 </b></p><p><b>如果您未满18周岁，请在您的法定监护人的陪同下阅读本协议，并在取得监护人对您使用本公司提供的服务及向本公司支付费用等行为的同意，并认可本协议、《个人信息保护政策》、《儿童个人信息保护政策》的全部条款内容后，方可使用本公司游戏服务。如您为未成年人的法定监护人，请特别注意第5.11条、5.12条及第12条。如您是14周岁以下（含）的未成年人或其法定监护人，请访问本公司《儿童个人信息保护政策》。


 </b></p><p>如果您对本协议或本公司游戏服务有意见或建议，可与本协议中约定的本公司客户服务部门联系，我们会给予您帮助。如果您对本协议或本公司游戏服务有意见或建议，可与本协议中约定的本公司客户服务部门联系，我们会给予您帮助。一旦您点击“同意”键、“接受”键或安装、使用、注册或以其他方式访问我们的服务，即视为您已详细阅读理解了本协议的全部内容，并同意遵守本协议的规定，所以请您务必在点击操作前仔细、完整地阅读本协议。


 </p><p><b>更新时间：2025.05.30</b>

 </p><p><b>生效时间：2025.05.30</b>



 </p><p><b>1. 定义</b>
 </p><p>如无特别说明，下列术语在本协议中的含义为：

 </p><p>1.1本协议：指本协议正文、《个人信息保护政策》、《儿童个人信息保护政策》、《游戏规则》及上述文件的修订版本。上述内容一经正式发布，即成为本协议不可分割的组成部分，具有同等法律效力。

 </p><p>1.2游戏规则：指本公司不时发布并修订更新的关于本公司游戏的用户守则、玩家条例、游戏公告、提示及通知等内容。

 </p><p>1.3本公司：指向您提供本公司游戏及其他服务的梅州实渲网络科技有限责任公司，在本协议中简称为“本公司”。

 </p><p>1.4本公司游戏：指由本公司负责运营的游戏的统称，包括计算机客户端游戏、网页游戏、HTML5游戏（H5游戏）、移动终端游戏、电视端游戏以及其他形式的游戏；本公司游戏可能以软件形式提供，这种情况下，本公司游戏还包括相关软件及文档。

 </p><p>1.5本公司游戏服务：指本公司向您提供的与游戏相关的各项运营服务。

 </p><p>1.6您：又称“玩家”或“用户”，指被授权使用本公司产品及其服务的自然人。

 </p><p>1.7游戏数据：指您在使用本公司游戏过程中产生的被服务器记录的各种数据，包括但不限于角色数据、虚拟物品数据、行为日志、购买日志等数据。

 </p><p>1.8虚拟币：指本公司为满足用户在本公司游戏服务中的正常交易交流需求，而设计的一种虚拟道具，通过人民币兑换等途径获得，可用于换取游戏中指定的各类增值服务，仅限于在本公司的特定游戏中使用和流通，虚拟币不能兑换为货币。



 </p><p><b>2. 协议的生效和变更</b>
 </p><p>2.1在您安装、使用或以其他方式访问本公司服务的同时，您需同意遵守本用户协议。如果您不同意遵守本用户协议，请勿安装、使用或以其他方式访问相关服务。本公司保留在您不同意本协议的情况下拒绝为您提供服务的权利。

 </p><p>2.2本公司有权决定变更（包括但不限于修改、增加或删减）《用户协议》和《个人信息保护政策》和其他相关文件。您如果继续使用相关服务，则视为您接受上述变更。如果您届时不同意变更后的《用户协议》、《个人信息保护政策》、行为准则中的全部或部分内容，请您立即停止使用服务，您与本公司形成的合同关系将终止。

 </p><p><b>3. 游戏账号</b>
 </p><p>3.1 您如果需要使用本公司游戏服务，则您需同意本协议条款，登录实名注册系统并按照注册页面的要求完成注册程序，包括但不限于输入正确完整的基本资料和信息。

 </p><p>您进行实名注册时，应提供有关您本人真实、合法、准确、有效的身份信息及其他相关信息进行注册，且不得以他人身份资料进行实名注册并接受服务，否则，本公司有权终止为您提供游戏服务，并有权对您的游戏账号采取包括但不限于警告、限制或禁止使用游戏账号全部或部分功能、删除游戏账号及游戏数据、删除相关信息、封禁游戏账号（以下简称“封号”）及注销账号等处理措施（为描述方便，下文有时也将上述处理措施称为“处罚”），因此造成的一切后果由将您自行承担，如您的行为造成本公司损失，本公司保留要求您赔偿所有损失的权利。

 </p><p>您同意以您提供的真实个人信息作为认定用户与游戏账号关联性的唯一依据。您以真实个人信息注册成为本公司用户后，基于合理理由需要修改注册个人身份资料信息的，本公司在通过对您个人身份信息的验证比对后，将及时、有效地为您提供该项服务。

 </p><p>如您不进行实名注册，或您提供的注册信息不完整的，则您可能无法使用本公司游戏，或在使用本公司游戏过程中会受到相应限制。

 </p><p>3.2如您使用本公司认可的第三方账号作为游戏账号使用和享受本公司游戏的，您还应遵守有关该第三方账号的协议、规则，且因该第三方账号产生的相关问题(包括但不限于被盗等)，您应自行联系该第三方进行解决，本公司可视情况提供相应的协助。

 </p><p>3.3您充分理解并同意，本公司会按照国家相关部门的要求将您的实名注册信息运用于防沉迷系统之中，即本公司可能会根据您的实名注册信息判断您是否年满18周岁、您提交的实名身份信息是否规范或实名验证是否通过等，从而决定是否对您的游戏账号予以防沉迷限制。

 </p><p>3.4您充分理解并同意，本公司有权审查您注册时所提供的身份信息是否真实、有效，以便采取技术与管理等合理措施保障您游戏账号的安全、有效。您应妥善保管您的游戏账号及所对应的密码，您应在知晓您的游戏账号被盗用后第一时间通知本公司。您应以正确、安全的方式使用您的账号及密码，如您未能正确、安全的方式使用您账号及密码，导致账号密码遗失、账号被盗等情形而给本公司和他方的权益造成损害的，应承担由此产生的法律责任。若您发现有他人冒用或盗用您的游戏账号及密码、或任何其他未经您合法授权使用的情形时，请您立即通过客服电话、邮箱通知本公司，告知本公司需采取的措施。您通知本公司时，应提供与您注册身份信息相一致的个人有效身份信息，本公司收到您的有效请求并核实身份后，会根据您的要求或结合具体情况采取相应措施（包括但不限于暂停该账号的登录和使用等），本公司因根据您的请求采取相应措施而造成您及其他用户损失的后果，将由您承担全部责任。如您通知本公司后，本公司未及时采取相应措施暂停您账号的登录和使用并给您造成损失的，本公司仅承担损失扩大部分的相应责任。若您没有提供有效身份信息或您提供的个人有效身份信息与所注册的身份信息不一致的，本公司有权拒绝您的请求，因此造成的损失将由您自行承担。
 </p><p>3.5您充分理解并同意，为提高本公司游戏服务的安全水平，本公司有权将有关技术或软件应用到本公司游戏中，但本公司不保证这些安全保障措施可以完全杜绝游戏账号被他人窃取或丢失的风险。

 </p><p>3.6您充分理解并同意，为高效利用服务器资源，如果您三年未使用游戏账号登录本公司游戏，本公司有权视需要，在提前通知您的情况下，对该游戏账号及其账号下的游戏数据及相关信息采取删除等处置措施，上述处置可能导致您对该游戏账号下相关权益的丧失，对此本公司无须承担任何责任。

 </p><p>3.7您理解并同意，您不得将游戏账号以任何方式提供给他人使用，包括但不限于不得以转让、出租、借用等方式提供给他人作包括但不限于直播、录制、代打代练等商业性使用。否则，因此产生任何法律后果及责任均由您自行承担，且本公司有权对您的游戏账号采取包括但不限于警告、限制或禁止使用游戏账号全部或部分功能、删除游戏账号及游戏数据及其他相关信息、封号直至注销等处理措施，因此造成的一切后果由您自行承担。

 </p><p>3.8为了维护您的合法权益，您在向本公司提供与您注册的身份信息相一致的个人有效身份信息后，您有权以书面形式要求本公司提供本人账号注册人证明、原始注册信息等必要的协助和支持，本公司在核查您要求的合法性及合理性后，将在合理范围里给予您相应协助或拒绝您的要求，同时将根据您的书面请求向有关行政机关和司法机关提供相关证据信息资料，但对于您反复多次的请求所带来的费用支出，本公司有权要求您承担。



 </p><p><b>4. 用户信息收集、使用及保护</b>
 </p><p>4.1尊重及保护用户个人信息和隐私是本公司的一项基本原则。本公司承诺，本公司游戏服务对用户个人信息的收集、存储、使用、共享、转让、公开披露、删除等个人信息处理活动将遵循本协议、《个人信息保护政策》的约定及相关法律法规的规定。针对14周岁以下（含）的未成年人的个人信息及隐私保护事宜，适用《儿童个人信息保护政策》。

 </p><p><b>5. 本公司游戏服务</b>
 </p><p>5.1在您遵守本协议及相关法律法规的前提下，本公司给予一项您个人的、不可转让及非排他性的许可，以使用本公司游戏服务。您仅能以非商业目的使用本公司游戏服务，包括：

 </p><p>5.1.1接收、下载、安装、启动、升级、登录、显示、运行和/或截屏本公司游戏；

 </p><p>5.1.2创建游戏角色，设置网名，查阅游戏或应用规则、用户个人资料、游戏对战结果，开设游戏房间、设置游戏参数，在游戏中购买、使用游戏道具、游戏装备、游戏币等，使用聊天功能、社交分享功能；

 </p><p>5.1.3使用本公司游戏支持并允许的其他某一项或几项功能。

 </p><p>5.2在本公司游戏以软件形式提供服务的情况下，您在使用本公司游戏及本公司游戏服务时还应符合本协议第六条关于软件许可的规定。

 </p><p>5.3本条及本协议其他条款未明示授权的其他一切权利仍由本公司保留，您在行使这些权利时须另外取得本公司的书面许可。

 </p><p>5.4如果本公司发现或收到他人举报或投诉您违反本协议约定，本公司有权采取相应的措施进行处理，该措施包括但不限于：不事先通知您的情况下对相关内容进行删除，并视行为情节对违规游戏账号处以包括但不限于警告、限制或禁止使用全部或部分功能、封号直至注销的处罚，并公告处理结果，同时有权要求您赔偿因您从事违约行为而给本公司造成的损失等。

 </p><p>5.5您充分理解并同意，本公司有权依合理判断对违反有关法律、法规、部门规章规定、行政机关的通知或本协议规定的行为进行处理，对违法、违规、违约的用户采取适当的法律措施，并依法依规保存有关信息向有关部门报告等，用户应承担由此而产生的法律责任。

 </p><p>5.6您充分理解并同意，如您因违反本协议或相关服务条款的规定，导致或产生第三方主张向您或本公司主张的赔偿或其他权利将由您单独承担；本公司因此遭受损失，有权要求您承担赔偿责任。

 </p><p>5.7本公司有权自主决定本公司游戏及本公司游戏服务的收费方式和资费标准。您充分理解并同意：游戏道具、游戏装备、游戏币以及其他增值服务等是本公司游戏服务的一部分，本公司在此许可您依本协议而获得其使用权。您购买、使用游戏道具、游戏装备、游戏币以及其他增值服务等应遵循本协议、游戏具体规则的要求；同时，游戏道具、游戏装备、游戏币等受到有效期限的限制，除不可抗力或可归责于本公司的原因外，一旦有效期届满，会自动失效，如游戏终止运营的，该有效期截止到运营终止之日。

 </p><p>5.8您充分理解并同意：为更好地向用户提供本公司游戏服务，本公司有权对游戏中的内容或构成元素等作出调整、更新或优化（包括但不限于您购买或正在使用的角色、游戏装备及其他游戏道具的性能及相关数值设置等作出调整、更新或优化），如您继续接受本公司游戏服务，则表明您同意前述行为且不会因此追究本公司的法律责任。

 </p><p>5.9您充分理解并同意：为了保证您及其他用户的游戏体验，本公司有权定期转移或者清除本公司游戏服务器上存储的一些过往的游戏数据。

 </p><p>5.10本公司将按照相关法律法规和本协议的规定，采取切实有效的措施保护未成年人在使用本公司游戏服务过程中的合法权益，包括可能采取技术措施、禁止未成年人接触不适宜的游戏或者游戏功能、限制未成年人的游戏时间、预防未成年人沉迷网络。作为游戏规则的一部分，本公司还将在适当位置发布本公司游戏用户指引和警示说明，包括游戏内容介绍、正确使用游戏的方法以及防止危害发生的方法。所有未成年人用户都应在法定监护人的指导下仔细阅读并遵照执行这些指引和说明；其他玩家在使用本公司游戏服务的过程中应避免发布、产生任何有损未成年人身心健康的内容，共同营造健康游戏环境。

 </p><p>5.11如果您未满18周岁的，为保障您的合法权益，本公司有权依据国家有关法律法规及政策规定、本协议其他条款规定或根据您法定监护人的合理要求采取以下一种或多种措施：

 </p><p>5.11.1将与您游戏相关的信息（包括但不限于您游戏账号的登录信息、充值流水信息等）提供给您的法定监护人，使得您法定监护人可及时或同步了解您游戏情况；

 </p><p>5.11.2限制您游戏账号的消费额度；

 </p><p>5.11.3采取技术措施屏蔽某些游戏或游戏的某些功能，或限定您游戏时间或游戏时长；

 </p><p>5.11.4注销或删除您游戏账号及游戏数据等相关信息；

 </p><p>5.11.5您法定监护人要求采取的，或本公司认为可采取的其他合理措施，以限制或禁止您使用本公司游戏。

 </p><p>5.12本公司向用户提供游戏服务本身属于商业行为，用户有权自主决定是否根据本公司自行确定的收费项目（包括但不限于购买游戏道具、游戏装备、游戏虚拟币的使用权以及接受其他增值服务等各类收费项目）及收费标准支付相应的费用，以获得相应的游戏服务。如您不按相应标准支付相应费用的，您将无法获得相应的游戏服务。您知悉并同意：收费项目或收费标准的改变、调整是一种正常的商业行为，您无权因为收费项目或收费标准的改变、调整而要求本公司进行赔偿或补偿。如您付费购买游戏服务的交易因退款或构成无效民事法律行为等需要取消或恢复原状的，本公司有权就该交易对应发放到相应游戏账号中的游戏道具、游戏装备、游戏虚拟币、其他增值服务等收费项目内容进行扣除；如前述待扣除的收费项目内容已赠送给其他用户或您为前述收费项目内容的受赠用户时，您同意本公司可从受赠的游戏账号中扣除该部分收费项目内容；如前述发放的游戏账号或受赠的游戏账号中的游戏道具、游戏装备、游戏虚拟币、其他增值服务等不足以扣除的，就不足部分，本公司可在发放的游戏账号或受赠的游戏账号中的游戏道具、游戏装备、游戏虚拟币、其他增值服务后续增加时优先扣除。

 </p><p>5.13在任何情况下，本公司不对因不可抗力导致的您在使用本公司游戏服务过程中遭受的损失承担责任。该等不可抗力事件包括但不限于国家法律、法规、政策及国家机关的命令及其他政府行为或者其它的诸如地震、水灾、雪灾、火灾、海啸、台风、罢工、战争、黑客攻击等不可预测、不可避免且不可克服的事件。

 </p><p>5.14本公司游戏可能因游戏软件BUG、版本更新缺陷、第三方病毒攻击或其他因素导致您的游戏角色、游戏道具、游戏装备及游戏币等账号数据发生异常。在数据异常的原因未得到查明前，本公司有权暂时冻结该游戏账号；若查明数据异常为非正常游戏行为所致，本公司有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），且本公司无须向您承担责任。

 </p><p>5.15如您从未经本公司授权的第三方处购买、接受赠与或者通过其他的方式获得游戏账号、游戏道具、游戏装备、游戏币的，本公司不对您上述的行为负责，并且不受理由此发生的纠纷而带来的申诉。

 </p><p>5.16您充分理解到：不同操作系统之间存在不互通的客观情况，该客观情况并非本公司造成，由此可能导致您在某一操作系统中的充值和游戏数据不能顺利转移到另一操作系统中。请您保持在同一操作系统中使用本公司游戏，由于您在不同系统进行切换造成的充值损失和游戏数据丢失风险应由您自行承担，本公司对此不承担责任。

 </p><p>5.17本公司自行决定终止或因为其他原因终止运营本公司游戏时，本公司会按照文化部有关网络游戏终止运营的相关规定处理游戏终止运营相关事宜，以保障用户合法权益。

 </p><p>5.18本公司保留在其认为有必要的情况下，终止或部分终止提供本公司游戏服务的权利，终止前将提前60天予以公告，请您籍此适当使用本公司的游戏。不管由于何种原因导致本公司游戏服务终止，用户应采取相应的措施自行处理游戏虚拟物品，包括但不限于注销或停止使用用户账号、游戏虚拟物品等相关事宜。用户不得因本公司游戏服务全面终止而要求本公司承担除用户已经购买但尚未使用的游戏虚拟币外任何形式的赔偿或补偿责任，包括但不限于因不再能继续使用用户账号、游戏虚拟物品等而要求的赔偿。

 </p><p><b>6. 软件许可</b>
 </p><p>6.1使用本公司游戏服务可能需要下载并安装相关软件，请您直接从本公司的相关网站上获取该软件，或从得到本公司授权的第三方获取该软件。如果您从未经本公司授权的第三方获取本公司游戏或与本公司游戏名称相同的游戏，将视为您未获得本公司授权，本公司无法保证该游戏能够正常使用，且对您因此造成的损失不承担责任。

 </p><p>6.2本公司可能为不同的终端设备或操作系统开发了不同的软件版本，包括但不限于Windows、iOS、Android、Windows Phone、Symbian、Blackberry等多个应用版本，您应当根据实际情况选择下载合适的版本进行安装，下载安装程序后，您需要按照该程序提示的步骤正确安装。

 </p><p>6.3若本公司游戏以软件形式提供游戏服务，本公司给予一项您个人的、非商业使用的、可撤销的、可变更的、不可转让、不可转授权及非排他性的许可。您需遵循本协议第五条的规定来使用本公司提供的游戏服务。

 </p><p>6.4如您有需要在个人使用的范围以外使用本公司游戏及本公司游戏服务，或者将本公司游戏与本公司游戏服务用于任何商业用途，则应与本公司联系并获得本公司另行授权。任何未经本公司许可的安装、使用、访问、显示、运行、商业使用等行为均属对本公司的侵权。

 </p><p>6.5如果您不再需要使用该软件或者需要安装新版，可以自行卸载。如果您愿意帮助本公司改进产品服务，请告知卸载的原因。

 </p><p>6.6为了保证本公司游戏服务的安全性和功能的一致性，本公司有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。

 </p><p>6.7软件新版本发布后，旧版本的软件可能无法使用。本公司不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。

 </p><p><b>7. 用户行为规范</b>
 </p><p>7.1您充分了解并同意：您除了对登录后所持账号产生的行为依法享有权利外，您还必须为自己游戏账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本公司游戏中的内容自行加以判断，并承担因使用本公司游戏服务而引起的所有风险，包括因对本公司游戏内容的正确性、完整性或实用性的依赖而产生的风险。本公司无法且不会对因前述风险而导致的任何损失或损害承担责任。

 </p><p>7.2您除了可以按照本协议的约定使用本公司游戏服务之外，不得进行任何侵犯本公司游戏的知识产权的行为，或者进行其他的有损于本公司或其他第三方合法权益的行为。

 </p><p>7.3 您在使用本公司游戏或本公司游戏服务时须遵守法律法规，不得利用本公司游戏或本公司游戏服务从事违法违规行为，一经发现，本公司有权立即终止对您提供服务，并不承担任何责任，包括但不限于以下行为：

 </p><p>7.3.1违反宪法确定的基本原则的；

 </p><p>7.3.2危害国家统一、主权和领土完整的；

 </p><p>7.3.3泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；

 </p><p>7.3.4煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；

 </p><p>7.3.5宣扬邪教、迷信的；

 </p><p>7.3.6散布谣言，扰乱社会秩序，破坏社会稳定的；

 </p><p>7.3.7宣扬淫秽、色情、赌博、暴力，或者教唆犯罪的；

 </p><p>7.3.8侮辱、诽谤他人，侵害他人合法权益的；

 </p><p>7.3.9违背社会公德的；

 </p><p>7.3.10有法律、行政法规和国家规定禁止的其他内容的；

 </p><p>7.3.11发布违法信息，并实施其他严重违背社会公德、以及其他违反法律禁止性规定的行为的。

 </p><p>7.4除非法律允许或本公司书面许可，您从事下列用户不正当、禁止性行为时，本公司有权终止对您提供服务并要求您承担相应法律责任：

 </p><p>7.4.1删除本公司游戏软件及其副本上关于著作权的信息；

 </p><p>7.4.2对本公司游戏软件进行扫描、探查、测试，以检测、发现、查找其中可能存在的BUG或弱点；

 </p><p>7.4.3对梅州实渲游戏软件进行扫描、探查、测试，以检测、发现、查找其中可能存在的BUG或弱点；

 </p><p>7.4.4对本公司游戏软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经合法授权的第三方工具/服务接入软件和相关系统；

 </p><p>7.4.5修改或伪造本公司软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论上述行为是否为商业目的；

 </p><p>7.4.6通过非本公司开发、授权的第三方软件、插件、外挂、系统，使用本公司游戏及本公司游戏服务，或制作、发布、传播非本公司开发、授权的第三方软件、插件、外挂、系统；

 </p><p>7.4.7对游戏中本公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；

 </p><p>7.4.8建立有关本公司游戏的镜像站点，或者进行网页（络）快照，或者利用架设服务器等方式，为他人提供与本公司游戏服务完全相同或者类似的服务；

 </p><p>7.4.9将本公司游戏的任意部分分离出来单独使用，或者进行其他的不符合本协议的使用；

 </p><p>7.4.10使用、修改或遮盖本公司游戏的名称、商标或其它知识产权；

 </p><p>7.4.11提供虚假身份信息进行用户注册、游戏充值等行为；

 </p><p>7.4.12其他未经本公司明示授权的行为。

 </p><p>7.5您在使用本公司游戏服务过程中有如下任何行为的，本公司有权视情节严重程度，依据本协议及相关游戏规则的规定，对您做出暂时或永久性地封号、删除游戏账号及游戏数据、无偿收回游戏虚拟物品、删除相关信息等处理措施，且本公司保留追究您的法律责任的权利：

 </p><p>7.5.1以某种方式暗示或伪称本公司内部员工或某种特殊身份，企图得到不正当利益或影响其他用户权益的行为；

 </p><p>7.5.2在本公司游戏中使用非法、不当或违反公序良俗的词语、字符等，包括用于角色命名；

 </p><p>7.5.3以任何方式破坏本公司游戏或影响本公司游戏服务的正常进行；

 </p><p>7.5.4各种非法外挂行为；

 </p><p>7.5.5传播非法言论或不当信息；

 </p><p>7.5.6盗取他人游戏账号、游戏物品；

 </p><p>7.5.7私自进行游戏账号交易；

 </p><p>7.5.8私自进行游戏虚拟币、游戏装备、游戏币及其他游戏道具等交易；

 </p><p>7.5.9利用bug或非正常游戏方式提升游戏角色数据、游戏内的角色排名的行为；

 </p><p>7.5.10违反本协议任何约定的；

 </p><p>7.5.11其他在行业内被广泛认定的不当行为，无论是否已经被本协议或游戏规则明确列明。

 </p><p>您知悉并同意，由于外挂具有隐蔽性或用完后即消失等特点，本公司有权根据您的游戏数据和表现异常判断您有无使用非法外挂等行为。

 </p><p>7.6 您知悉并同意，如本公司依据本协议对您的游戏账号采取封号处理措施的，具体封号期间由本公司根据您违规行为情节而定。

 </p><p>您知悉并同意：

 </p><p>7.6.1在封号期间，您游戏账号中的游戏虚拟币、游戏装备、游戏币及其他游戏道具可能都将无法使用；

 </p><p>7.6.2如前述游戏虚拟币、游戏装备、游戏币及其他游戏道具存在一定有效期，该有效期可能会在封号期间过期，您游戏账号解封后，您将无法使用该等已过期的游戏虚拟币、游戏装备、游戏币及其他游戏道具。

 </p><p>据此，您无权因发生前述 7.6.1和（或）7.6.2规定的情形而追究本公司的法律责任。



 </p><p><b>8. 免责声明</b>
 </p><p>8.1本公司游戏服务以“现状”提供给您。本公司不保证：本公司游戏服务无错误及不会中断、所有缺陷已被更正、或本公司游戏服务不会受到病毒或任何其它因素的损害。除非有法律明确规定，基于现有技术条件等限制，本公司在此明确声明不承担任何明示或默示的担保责任，包括但不限于对本公司游戏服务的性能、适用性或不侵权的担保。

 </p><p>8.2 您充分理解并同意：您充分理解并同意：第三方在本公司游戏中投放的广告、链接或者其它形式的推广内容，均是由自行提供的，本公司基于目前的技术水平无法逐一核查广告内容的风险，请您务必仔细核实广告内容的真实性、合法性，本公司对其推广内容不作任何明示或者默示的担保，您未尽注意义务产生的法律后果将由您自行承担。

 </p><p><b>9. 知识产权</b>
 </p><p>9.1本公司依法享有本公司游戏软件的一切合法权益（包括但不限于其中涉及的计算机软件著作权、美术作品著作权、商标权、专利权等知识产权）；与本公司游戏相关的所有信息内容（包括文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）及商业秘密均归本公司所有。本公司有权运营该等本公司游戏软件，或已从合法权利人处取得合法授权，并有权为用户提供本公司游戏软件及本公司游戏服务。未经本公司事先书面同意，您不得以任何方式将本公司游戏（包括本公司游戏整体及本公司游戏涉及的所有内容、组成部分或构成要素）进行商业性使用。

 </p><p>9.2尽管本协议有其他规定，您在使用本公司游戏服务中产生的账号数据信息、角色数据信息、等级、排行榜数据及虚拟物品数据信息（包括但不限于增值服务币、游戏道具等，但用户的姓名、身份证号、电话号码等个人身份信息数据除外）等游戏数据的所有权和知识产权归本公司所有，并由本公司进行管理，本公司有权在游戏内对玩家的游戏数据进行展示，包括但不限于在游戏排行榜中展示玩家游戏数据（战斗力、等级、竞技场排名等），本公司有权对该游戏数据行使权利。其中，本公司对用户购买游戏虚拟币的购买记录的保存期限将遵守相关法律法规等规范文件的规定。对其他游戏数据的保存期限为两年，但国家法律法规另有规定的从其规定。

 </p><p>9.3本公司游戏可能涉及第三方知识产权，而该等第三方对您基于本协议在本公司游戏中使用该等知识产权有要求的，本公司将以适当方式向您告知该要求，您须一并遵守。

 </p><p>9.4本公司尊重知识产权并注重保护用户享有的各项权利。在本公司游戏服务中，您可能需要通过上传、发布等各种方式向本公司提供内容。在此情况下，您仍然享有此等内容的完整知识产权。您在此明确同意，本公司及其关联公司有权在本公司提供的游戏服务中使用、传播、复制、展示此等内容。

 </p><p><b>10. 单机游戏特别说明</b>
 </p><p>如您使用的本公司游戏为单机游戏，充值系统仅在接入互联网或移动通信网（短代支付等）后方可使用，如您使用充值系统进行充值，将通过互联网或移动通信网（短代支付等）确认充值信息。单机游戏的本公司游戏服务中，全部游戏数据将保存在您的移动智能设备上，一旦您卸载、重装本公司游戏软件，或您的移动智能设备损坏导致本公司游戏软件无法正常启动的，您的全部游戏数据将无法恢复。如您需将游戏数据保存在游戏服务器中的，需要联网进行数据保存操作。



 </p><p><b>11. 未成年人使用本公司的服务</b>
 </p><p>11.1公司非常重视对未成年人个人信息的保护，18周岁以下的未成年人未经法定监护人同意不得使用本公司的服务。如您是18周岁以下的未成年人的法定监护人，则应监督和管控该未成年人使用本公司服务的行为，该未成年人创建账户、购买本公司服务等行为应通过您的事先同意。

 </p><p>11.2家长控制措施。如您为未成年人的家长，出于防止您的子女沉迷游戏等合理要求，本公司向您提供家长监护工程服务，当您发现自己的子女过于沉迷游戏时，您可提供合法的监护人资质证明、游戏名称账号、以及您对于限制强度的愿望等信息，向本公司申请对您子女的游戏账号采取相应限制措施（包括但不限于限制游戏时间区间及长度等），解决您子女沉迷游戏的不良现象，具体条件及申请要求请访问梅州实渲“家长控制”“”页面，本公司有权根据您提交的申请材料具体决定是否采取相应措施。



 </p><p><b>12. 遵守当地法律监管</b>
 </p><p>12.1您在使用本公司游戏服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此承担全部责任。

 </p><p>12.2您使用本公司游戏服务时，应依法、理性发表言论，如您的言论、行为有可能使本公司面临政治和社会风险，本公司将暂停或终止对您的服务。

 </p><p><b>13. 管辖与法律适用</b>
 </p><p>13.1本协议签订地为中华人民共和国广东省深圳市南山区。

 </p><p>13.2本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。

 </p><p>13.3若您和本公司之间因本协议发生任何纠纷或争议，首先应友好协商解决；协商不成的，您与本公司同意，将纠纷或争议提交至梅州仲裁委员会进行仲裁，并同意使用该仲裁院的仲裁规则。

 </p><p>13.4本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。



 </p><p><b>14. 其他</b>
 </p><p>14.1发票开具：如您是通过本公司官网或本公司的自有渠道购买本公司的服务，您可在本公司提供的服务中支付费用之日起30日内与本公司联系发票开具事宜。您需要提供详细的消费单号、消费项目、金额、收件人联系方式、收件地址、纳税识别码等信息，本公司将在收到您反馈的上述全部资料之日起30个工作日内以快递等方式向您提供发票原件，到付的快递费用由您自行承担。如您是通过第三方运营商或渠道购买本公司的服务，您应向该第三方收费主体索取发票。

 </p><p>14.2安全漏洞信息接收：如您在使用梅州实渲游戏服务过程中发现相应游戏产品存在安全漏洞，您可以通过我们的邮箱（mzsxkefu@mzsxgames.com）向我们反馈，我们将及时组织对安全漏洞进行修补，以为用户提供更优质安全的游戏服务。

 </p><p>14.3根据国家关于健康游戏的忠告，本公司提醒您：抵制不良游戏，拒绝盗版游戏；注意自我保护，谨防受骗上当；适度游戏益脑，沉迷游戏伤身。

 </p><p>14.4邮箱：mzsxkefu@mzsxgames.com，通讯地址：梅州市梅江区三角镇富奇路富奇城2栋第8号，邮编：514021</p>

  </div>
</template>
<script>

export default {  
};
</script>